import { ArgsType, Field, Int } from '@nestjs/graphql'
import { DeleteDtoInterface } from '../base/deleteDto.interface'

@ArgsType()
export class BaseDeleteDto<T> implements DeleteDtoInterface {
  @Field(t => Int)
  id!: number

  public constructor (partial?: Partial<T>) {
    Object.assign(this, partial)
  }
}
